export const zIndex = {
    creator: 500,
    universalNavBar: 200,
    mainNavigation: 100,
    popover: 50,
    searchBar: 25,
};
